//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import constant from '~/const';
import Pagination from '~/components/Pagination.vue';
import Filters from './StatisticsMerchantsFilters.vue';
import User from '~/components/User.vue';
import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    Pagination,
    User,
  },

  data() {
    return {
      tableConfig,
      constant,
      timer: 60,
      timerId: null,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),
    ...mapState('statisticsMerchants', ['data', 'page', 'pages', 'shouldUpdate']),
  },

  mounted() {
    this.startTimer();
  },

  beforeDestroy() {
    clearInterval(this.timerId);
  },

  methods: {
    ...mapActions('common', [
      'setGeneralLoader',
      'setSuccessNotification',
      'setErrorNotification',
    ]),
    ...mapActions('statisticsMerchants', {
      loadDataAction: 'loadData',
      setPageAction: 'setPage',
    }),

    startTimer() {
      this.timerId = setInterval(async () => {
        if (this.timer === 0) {
          const now = moment();
          const fromDate = now.clone();
          fromDate.subtract(5, 'minutes');
          const payload = {
            fromDate: fromDate.unix(),
            toDate: now.unix(),
          };
          if (this.shouldUpdate) {
            await this.loadDataAction(payload);
          }
          this.timer = 60;
        } else {
          this.timer -= 1;
        }
      }, 1000);
    },

    async applyFilters() {
      try {
        this.setGeneralLoader(true);
        await this.loadDataAction();
        this.setGeneralLoader(false);
      } catch (error) {
        this.setErrorNotification(error.message);
      }
    },

    setPage(value) {
      this.setPageAction(value);
      this.loadDataAction();
    },
  },
};
